import MappingToolbar from './MappingToolbar';

export default MappingToolbar;
